import type { ColorMode } from '@hypercodestudio/basler-components';

import type { IContentPage } from '~~/lib/ContentfulService';
import { pageToDefaultThemeMap } from '~/utils/pageToDefaultThemeMap';
import type { GetContentType } from '~/types/GetContentType';

export function resolvePageTheme(page: IContentPage): ColorMode {
  return (
    page.fields.pageTheme ??
    pageToDefaultThemeMap[
      page.sys.contentType.sys.id as GetContentType<IContentPage>
    ]
  );
}
